import { Modal, Table, Typography } from "antd";

import dayjs from "dayjs";

const { Title } = Typography;

const ModalHistory = ({ open, title, onClose, tableProps = {}, t }) => {
  const columns = [
    {
      title: t("history:History_Table.Date_Time"),
      dataIndex: "action_time",
      width: "20%",
      render: (txt) => (txt ? dayjs(txt).format("YYYY-MM-DD HH:mm:ss") : undefined),
    },
    {
      title: t("history:History_Table.User"),
      dataIndex: "username",
      width: "20%",
    },
    {
      title: t("history:History_Table.Action"),
      width: "60%",
      dataIndex: "messageList",
      render: (messageList) =>
        (messageList ?? []).map((item, i) => (
          <div className="mb-2" key={i}>
            {item}
          </div>
        )),
    },
  ];

  return (
    <Modal
      title={<Title level={4}>{title}</Title>}
      width={"80%"}
      open={open}
      onCancel={onClose}
      footer={null}
      maskClosable={false}
      destroyOnClose
    >
      <div className="mt-6">
        <Table key={"key"} columns={columns} scroll={{ y: 500 }} {...tableProps} />
      </div>
    </Modal>
  );
};

export default ModalHistory;
